import { Component, OnInit } from '@angular/core';
import { DELIVERYSUBSCRIPTION_PLANS_PATH } from '@woolworthsnz/shop';
import { DeliverySubscriptionPlan } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeliverySubscriptionService } from '../../../delivery-subscription/service/delivery-subscription.service';
import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { SvgIconComponent } from '@woolworthsnz/styleguide';

@Component({
	selector: 'wnz-delivery-saver-tag',
	templateUrl: './delivery-saver-tag.component.html',
	styleUrls: ['./delivery-saver-tag.component.scss'],
	standalone: true,
	imports: [SvgIconComponent, AsyncPipe, CurrencyPipe],
})
export class DeliverySaverTagComponent implements OnInit {
	deliverySubscriptionBasePlan$: Observable<DeliverySubscriptionPlan>;
	deliverySubscriptionPlansPath = `/${DELIVERYSUBSCRIPTION_PLANS_PATH}`;

	constructor(private deliverySubscriptionService: DeliverySubscriptionService) {}

	ngOnInit(): void {
		this.deliverySubscriptionService.getPlans();
		this.deliverySubscriptionBasePlan$ = this.deliverySubscriptionService.state$.pipe(
			map((state) => this.deliverySubscriptionService.getBasePlan(state.allPlans))
		);
	}
}
